import React, { FormEvent, useEffect, useState } from "react";
import { ICriteriaGroup } from "../../../types/criteriaGroup";
import { CriteriaMethodEnum, ICriteria } from "../../../types/criteria";
import useUpdateCriteria from "../../../hooks/criteria/useUpdateCriteria";
import useCreateCriteria from "../../../hooks/criteria/useCreateCriteria";
import useDeleteCriteria from "../../../hooks/criteria/useDeleteCriteria";

interface ICriteriaProps {
  criteriaGroups: ICriteriaGroup[];
  currOption: number[];
  setCurrOption: React.Dispatch<React.SetStateAction<number[]>>;
  isDelete: boolean;
  setIsDelete: React.Dispatch<React.SetStateAction<boolean>>;
  setIsOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const Criteria = ({
  criteriaGroups,
  currOption,
  setCurrOption,
  isDelete,
  setIsDelete,
  setIsOpenDeleteModal,
}: ICriteriaProps) => {
  //eslint-disable-line

  const criteriaGroupIdx = currOption[0] || 0;
  const criteriaGroupId = criteriaGroups[criteriaGroupIdx].id;
  const criteriaId = currOption[1] || 0;
  const [criteria, setCriteria] = useState(criteriaGroups[0].criterias[0]);
  const [title, setTitle] = useState<string>("");
  const [isProcessRunning, setIsProcessRunning] = useState<boolean>(false);
  const [isServiceError, setIsServiceError] = useState<string | null>(null); //eslint-disable-line

  const blankCriteria: ICriteria = {
    criteria_group_id: criteriaGroupId ?? 0,
    method: CriteriaMethodEnum.AND,
    description: "",
    criteria_details: [],
  };

  useEffect(() => {
    if (criteriaId === criteriaGroups[criteriaGroupIdx].criterias.length) {
      setCriteria({ ...blankCriteria });
      setTitle("New criteria");
    } else {
      setCriteria(criteriaGroups[criteriaGroupIdx].criterias[criteriaId]);
      setTitle(
        criteriaGroups[criteriaGroupIdx].criterias[criteriaId].description
      );
    }
  }, [criteriaId, criteriaGroups]); //eslint-disable-line

  const { mutate: updateCriteria } = useUpdateCriteria({
    setIsProcessRunning,
    setIsServiceError,
  });
  const { mutate: createCriteria } = useCreateCriteria({
    setIsProcessRunning,
    setIsServiceError,
  });
  const { mutate: deleteCriteria } = useDeleteCriteria({
    setIsProcessRunning,
    setIsServiceError,
  });

  useEffect(() => {
    if (isDelete) {
      setCurrOption([criteriaGroupIdx, 0]);
      if (criteria.id) deleteCriteria(criteria.id);
      setIsDelete(false);
    }
  }, [isDelete]); //eslint-disable-line

  if (!criteria) {
    return <p>Loading...</p>;
  }

  const handleSave = (e: FormEvent) => {
    e.preventDefault();

    if (criteriaId === criteriaGroups[criteriaGroupIdx].criterias.length) {
      createCriteria(criteria);
    } else {
      updateCriteria(criteria);
    }
    setTitle(criteria.description);
  };

  const handleDelete = () => {
    if (criteriaId === criteriaGroups[criteriaGroupIdx].criterias.length) {
      if (!criteriaId) {
        setCurrOption([criteriaGroupIdx]);
      } else {
        setCurrOption([criteriaGroupIdx, 0]);
      }
      setCriteria(criteriaGroups[criteriaGroupIdx].criterias[criteriaId]);
    } else {
      setIsOpenDeleteModal(true);
    }
  };

  return (
    <div className="imm_quest_admin__content">
      <div className="content_head">
        <h3>
          {title ??
            (criteria.description ?? criteria.method
              ? `[${criteria.method}]`
              : "[AND]")}
        </h3>
      </div>

      <form onSubmit={handleSave} className="content_form">
        <div className="field">
          <label htmlFor="description">Description</label>
          <input
            id="description"
            name="description"
            placeholder="Enter description"
            value={criteria.description}
            onChange={(e) =>
              setCriteria({ ...criteria, description: e.target.value })
            }
          />
        </div>

        <div className="field">
          <label htmlFor="method">Method</label>
          <select
            id="method"
            name="method"
            value={criteria.method || CriteriaMethodEnum.AND}
            defaultValue={CriteriaMethodEnum.AND}
            onChange={(e) =>
              setCriteria({
                ...criteria,
                method: e.target.value as CriteriaMethodEnum,
              })
            }
          >
            <option value={CriteriaMethodEnum.AND}>and</option>
            <option value={CriteriaMethodEnum.OR}>or</option>
            <option value={CriteriaMethodEnum.NOT}>not</option>
          </select>
        </div>

        <div className="actions">
          <button className="delete_btn" type="button" onClick={handleDelete}>
            {isProcessRunning ? (
              <i className="imm_quest_admin__process_loader" />
            ) : criteriaId ===
              criteriaGroups[criteriaGroupIdx].criterias.length ? (
              "Cancel"
            ) : (
              "Delete"
            )}
          </button>
          <button className="save_btn" type="submit">
            {isProcessRunning ? (
              <i className="imm_quest_admin__process_loader" />
            ) : criteriaId ===
              criteriaGroups[criteriaGroupIdx].criterias.length ? (
              "Create"
            ) : (
              "Save"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Criteria;
